import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { CONTACT } from "@/constants/config";

const PROD_ORIGIN = "https://lavish808bulliezrescuedpaws.org";
const DEFAULT_OG_IMAGE =
  "https://customer-assets.emergentagent.com/job_bulldog-sanctuary/artifacts/g4vq3c1t_1782224774424.png";

function upsertMeta({ name, property, content }) {
  if (!content) return;
  const attr = name ? "name" : "property";
  const key = name || property;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function upsertLink(rel, href) {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

/**
 * Sets route-aware title, meta description, canonical + OG/Twitter tags.
 * Uses production canonical URL regardless of the current environment so that
 * search engines index the production domain even when crawling the preview.
 */
export default function PageMeta({ title, description }) {
  const { pathname } = useLocation();

  useEffect(() => {
    if (title) document.title = title;
    const url = PROD_ORIGIN + (pathname === "/" ? "/" : pathname);

    upsertMeta({ name: "description", content: description });
    upsertLink("canonical", url);

    upsertMeta({ property: "og:title", content: title || CONTACT.org });
    upsertMeta({ property: "og:description", content: description });
    upsertMeta({ property: "og:url", content: url });
    upsertMeta({ property: "og:type", content: "website" });
    upsertMeta({ property: "og:image", content: DEFAULT_OG_IMAGE });
    upsertMeta({ property: "og:site_name", content: CONTACT.org });

    upsertMeta({ name: "twitter:card", content: "summary_large_image" });
    upsertMeta({ name: "twitter:title", content: title || CONTACT.org });
    upsertMeta({ name: "twitter:description", content: description });
    upsertMeta({ name: "twitter:image", content: DEFAULT_OG_IMAGE });
  }, [title, description, pathname]);

  return null;
}
